import PostModel from '../model/posts';
export const GET_POSTS = 'GET_POSTS';
export const GET_POSTSS = 'GET_POSTSS';
export const GET_USER_POSTS = 'GET_USER_POSTS';

const toPost = (row, idKey = 'id') => {
  const post = new PostModel(
  row.id || row.postid || row[idKey],
  row.image,
  row.title,
  row.type || row.typed || row.post_type || row.postType,
  row.userid,
  row.tages,
  row.disc || row.discrption || row.description,
  row.time,
  row.thumbnail,
  Number(row.vCount ?? row.views ?? 0) || 0,
  row.comm,
  row.pCount,
  row.dCount,
  row.userImg,
  row.email,
  row.userLink
  );
  const cid = String(row.communityid || '').trim()
  const link = String(row.userLink || row.link || '')
  post.communityid = cid || (link.startsWith('c:') ? link.slice(2) : '')
  return post
}

const mapFeed = (ress) => {
  const datashort = [];
  const datahistory = [];
  const datalong = [];
  const data = [];
  for (const key in ress.msg) datashort.push(toPost(ress.msg[key], 'postid'));
  for (const key in ress.msg2) datahistory.push(toPost(ress.msg2[key], 'postid'));
  for (const key in ress.msg3) datalong.push(toPost(ress.msg3[key], 'id'));
  for (const key in ress.msg4) data.push(toPost(ress.msg4[key], 'id'));
  const isShortType = (post) => {
    const type = String(post?.type || '').trim().toLowerCase();
    return type === 's' || type === 'short' || type === 'shorts';
  };
  const onlyShorts = [];
  const seenShort = new Set();
  const addShort = (post) => {
    const id = String(post?.id || '');
    if (!id || seenShort.has(id)) return;
    seenShort.add(id);
    onlyShorts.push(post);
  };
  datashort.forEach(addShort);
  [...datalong, ...datahistory, ...data].filter(isShortType).forEach(addShort);
  const home = datalong.length ? datalong.filter(post => !isShortType(post)) : [];
  return { data, datahistory, datalong: home, datashort: onlyShorts };
};

const fetchFeed = async (userid, page, limit, category) => {
  const cat = String(category || '').trim();
  const userKey = userid || 'guest';
  const url = cat
    ? `/api/postAi/category/${encodeURIComponent(cat)}/${page}/${limit}`
    : `/api/postAi/history/${encodeURIComponent(userKey)}/${page}/${limit}`;
  let lastError = new Error('Could not load videos');
  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      const res = await fetch(url);
      const data = await res.json().catch(() => ({}));
      const dbCode = data?.msg?.code;
      if (dbCode === 'ER_USER_LIMIT_REACHED') {
        throw new Error('Database is busy (too many connections). Wait until the top of the hour, then refresh.');
      }
      if (res.ok && !dbCode) return data;
      lastError = new Error('Could not load videos');
    } catch (err) {
      lastError = err;
    }
    await new Promise(resolve => setTimeout(resolve, 400 * (attempt + 1)));
  }
  throw lastError;
};

export const get_posts = (page, limit, category, live) => {
  return async (dispatch, getState) => {
    const userid = getState().authReduse.id;
    const ress = await fetchFeed(userid, page, limit, category);
    if (live && !live()) return;
    const mapped = mapFeed(ress);
    dispatch({
      type: 'GET_POSTS',
      data: mapped.data,
      id: userid,
      datahistory: mapped.datahistory,
      followlong: mapped.datalong,
      followshort: mapped.datashort
    });
  }
}

export const get_my_posts = () => {
  return async (dispatch, getState) => {
    const userid = getState().authReduse.id;
    if (!userid) {
      dispatch({ type: GET_USER_POSTS, data: [] });
      return;
    }
    const res = await fetch(`/api/posts/userPosts/${encodeURIComponent(userid)}`);
    if (!res.ok) throw new Error('Could not load your posts');
    const ress = await res.json();
    const data = [];
    if (Array.isArray(ress)) {
      for (const key in ress) {
        const row = ress[key];
        if (!row?.id) continue;
        data.push(toPost({
          ...row,
          disc: row.disc || row.discrption || row.description,
          vCount: row.vCount || row.views,
          comm: row.comm || row.vcomments,
          pCount: row.pCount || row.vlikes,
          dCount: row.dCount || row.vdislikes
        }));
      }
    }
    dispatch({ type: GET_USER_POSTS, data });
  }
}

export const get_postss = (page, limit, category, live) => {
  return async (dispatch, getState) => {
    const userid = getState().authReduse.id;
    const ress = await fetchFeed(userid, page, limit, category);
    if (live && !live()) return { longs: 0, shorts: 0 };
    const mapped = mapFeed(ress);
    dispatch({
      type: 'GET_POSTSS',
      data: mapped.data,
      id: userid,
      datahistory: mapped.datahistory,
      followlong: mapped.datalong,
      followshort: mapped.datashort
    });
    return {
      longs: (mapped.datalong || []).length,
      shorts: (mapped.datashort || []).length
    }
  }
}
